import { dateStamp } from './download';

/**
 * Trigger the browser's print dialog with a filename-seeding title (§10.10). The browser
 * controls the final filename and settings; we only seed the suggested name.
 */
export function printReport(name: string, kind: 'report' | 'comparison' = 'report'): void {
  const previous = document.title;
  const label = kind === 'comparison' ? `PAL-Comparison-${dateStamp()}` : `PAL-Report-${name}-${dateStamp()}`;
  document.title = label;
  const restore = () => {
    document.title = previous;
    window.removeEventListener('afterprint', restore);
  };
  window.addEventListener('afterprint', restore);
  window.print();
  // Fallback restore in case afterprint never fires.
  setTimeout(restore, 1000);
}
